import { Tooltip } from '@mui/material';
import { limitedArrayList } from '../../utils/formattingUtils';

export const ArrayWithTooltip = ({ source, record, maxDisplay = 3 }) => {
  const fieldData = record?.[source] || [];

  return (
    <Tooltip
      title={fieldData.map((item) => <div key={item}>{item}</div>)}
      placement="top"
      arrow
    >
      {limitedArrayList(fieldData, maxDisplay)}
    </Tooltip>
  );
};
